import React, { useEffect } from "react";
import GameCard1 from "../assets/new/game-1.png";
import GameCard2 from "../assets/new/game-2.png";
import GameCard3 from "../assets/new/game-3.png";
import Title360 from "../assets/new/360-title.png";
import GameCard from "./GameCard";
import Header from "./Header";

export default function GameStarter({ handleStartBtn }) {
  useEffect(() => {
    const gameCards = document.querySelectorAll(".game-card");
    let timeout = 0;
    gameCards.forEach((item) => {
      setTimeout(() => {
        item.classList.add("show");
      }, timeout);
      timeout += 400;
    });
  });

  return (
    <div style={{ height: "100%" }}>
      <Header />
      <div className="starter-wrapper">
        <div>
          <h1 className="big-title" data-aos="zoom-in">
            <img src={Title360} alt="" style={{ verticalAlign: "middle" }} />
            Cari Insto
          </h1>
          <div className="game-cards-wrapper">
            <GameCard
              onClick={handleStartBtn}
              title="No More Red Eyes"
              image={GameCard2}
            />
            <GameCard title="Refresh Your Eyes" image={GameCard1} isLocked />
            <GameCard title="Cool Your Eyes" image={GameCard3} isLocked />
          </div>
          <div className="btn-wrapper">
            <button className="btn-start" onClick={handleStartBtn}>
              Mulai
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
